<template>
  <div justify="center">
    <v-dialog
      v-model="modal.active"
      persistent
      max-width="500">
      <v-card>
        <v-card-title :class="(modal.error) ? 'headline red--text' : 'headline black--text'">{{ modal.title }}</v-card-title>
        <v-card-text
          style="max-height: 400px; overflow: auto;"
          v-html="modal.msg"/>
        <v-card-actions>
          <v-spacer/>
          <div v-if="modal.optionsType === 'YN'">
            <v-btn
              v-for="(option, index) in modal.optionsYN"
              :key="index"
              :color="option.classe+' white--text'"
              text
              @click="responses(option)">{{ option && option.titulo ? option.titulo[idioma] : '' }}</v-btn>
          </div>
          <div v-else-if="modal.optionsType === 'OK'">
            <v-btn
              v-for="(option, index) in modal.optionsOK"
              :key="index"
              :color="option.classe+' white--text'"
              text
              @click="responses(option)">{{ option && option.titulo ? option.titulo[idioma] : '' }}</v-btn>
          </div>
          <div v-else>
            <v-btn
              v-for="(option, index) in modal.options"
              :key="index"
              :color="option.classe+' white--text'"
              text
              @click="responses(option)">{{ option && option.titulo ? option.titulo[idioma] : '' }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('app', ['animal', 'strings', 'idioma', 'modal'])
  },
  created () {
  },
  methods: {
    responses (option) {
      this.modal.returns = option.valor
      this.modal.active = !option.closes
      if (this.modal.responseCallback !== null) { this.modal.responseCallback(this.modal.returns) }
    }
  }

}
</script>
